import kiwi from '../../../../../model/kiwi.glb'
import PositionFrut from './multiFrut'

function Kiwi() {
    return (<>
        <PositionFrut model={kiwi} minHeight={-79} maxHeight={-97} scale={150}/>
    </>);
}

export default Kiwi;